import { parseResponse } from "../../utils/common_lib";
import { baseApi } from "../baseApi";
export const billingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    patientAdvancePayment: builder.query({
      query: (params) => {
        return {
          url: `/patient_advance_payments/search_list.json`,
          method: "GET",
          params: params,
        };
      },
      providesTags:["advancePaymentList"],
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
    getPaymentKeys: builder.mutation({
      query: (body) => ({
        url: "/secure_payments/ethizo_gateway_configs.json",
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    savePayment: builder.mutation({
      query: (body) => {
        return({
          url: "/secure_payments/save.json",
          method: "POST",
          body: body,
        })
      },
      invalidatesTags:["userInfo","advancePaymentList"],
      transformResponse: (response, meta, arg) => response,
    }),
    getUserInfo: builder.query({
      query: (params) => ({
        url: `/demographics/patient_summary.json`,
        method: "get",
        params,
      }),
      transformResponse: (response, meta, arg) => response?.response?.data,
      providesTags:["userInfo"]
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  usePatientAdvancePaymentQuery,
  useGetPaymentKeysMutation,
  useSavePaymentMutation,
  useGetUserInfoQuery
} = billingApi;
